module.exports = __webpack_public_path__ + "public/images/captcha-hexagon-selected.f763f8a60be108887bb975ae5d4a652d.svg";